<template>
  <div>
    <div class="container">
      <div class="tab-body">
        <div class="personal-form">
          <form>
            <section class="form-group">
              <div class="label">姓名</div>
              <div class="input">
                <input type="text" placeholder="请填写您的姓名" v-model="formData.RealName">
              </div>
            </section>

            <section class="form-group mt-20">
              <div class="label">手机号码</div>
              <div class="input">
                <input type="number" placeholder="请填写您的手机号码" v-model="formData.MobileTelephone">
              </div>
            </section>
            <section class="form-group mt-20">
              <div class="label">电子邮箱</div>
              <div class="input">
                <input type="text" placeholder="请填写您的电子邮箱" v-model="formData.Email">
              </div>
            </section>
          </form>
          <button class="btn-main btn-next" @click="onSubmit()" :disabled="disabled">下一步</button>
        </div>
      </div>
    </div>
    <footer-logo></footer-logo>
  </div>
</template>

<script>
import footerLogo from '@/components/footerLogo.vue'
export default {
  components: {
    'footer-logo': footerLogo
  },
  data() {
    return {
      disabled: false,
      formData: {
        Email: '',
        RealName: '',
        MobileTelephone: '',
        ticketId: this.$route.query.ticketId,
        buyCount: 1,
        activityId: this.$route.query.ActivityId
      }
    }
  },

  created() {
    this.getUserInfo()
  },
  methods: {
    getUserInfo() {
      this.$fetch('/api/Activity/GetSignupContactProfile').then(result => {
        this.formData.RealName = result.RealName
        this.formData.Email = result.Email
        this.formData.MobileTelephone = result.MobileTelephone
      })
    },
    checkForm() {
      if (this.validNull(this.formData.RealName)) {
        this.$dialog.toast({
          mes: '请输入真实姓名',
          timeout: 1500
        })
        return false
      } else if (this.validNull(this.formData.MobileTelephone)) {
        this.$dialog.toast({
          mes: '请输入手机号码',
          timeout: 1500
        })
        return false
      } else if (!this.isMobile(this.formData.MobileTelephone)) {
        this.$dialog.toast({
          mes: '手机号码格式不正确',
          timeout: 1500
        })
        return false
      } else if (this.validNull(this.formData.Email)) {
        this.$dialog.toast({
          mes: '请输入邮箱',
          timeout: 1500
        })
        return false
      } else if (!this.isEmail(this.formData.Email)) {
        this.$dialog.toast({
          mes: '邮箱格式不正确',
          timeout: 1500
        })
        return false
      } else {
        return true
      }
    },
    onSubmit() {
      var _this = this
      if (!this.checkForm()) {
        return
      }

      this.$router.push({
        name: 'activity-signup-form',
        query: this.formData
      })
    }
  }
}
</script>

<style lang='less' scoped>
.clearfix {
  &:after {
    content: '';
    clear: both;
    display: block;
  }
}

.fl-left {
  float: left;
}

.fl-right {
  float: right;
}

.mt-20 {
  margin-top: 20 / @rem-size;
}

.form-group {
  box-sizing: border-box;
  padding: 0 24 / @rem-size;

  &.error {
    input[type='text'] {
      border-color: red !important;
      background-color: #ff0000 + 250%;
    }

    textarea {
      border-color: red !important;
      background-color: #ff0000 + 250% !important;
    }

    .error-tip {
      display: block !important;
    }

    .label .error-tip {
      display: inline-block !important;
    }
  }

  span.field-validation-error {
    margin: 0 !important;
    padding: 0 !important;
    display: block;
    line-height: 0.05rem;
  }

  span.field-validation-error span {
    color: red;
    display: block;
    color: #f00;
    font-size: 0.22rem;
    line-height: 0.3rem;
    margin-top: 0.1rem !important;
  }

  .label {
    display: block;
    line-height: 60 / @rem-size;
    color: #3e3e3e;
    font-size: 30 / @rem-size;
  }

  .error-tip {
    display: block;
    color: red;
    font-size: 22 / @rem-size;
    line-height: 30 / @rem-size;
    margin-top: 10 / @rem-size !important;
    display: none;
  }

  .input {
    display: block;

    .yd-datetime-input {
      display: block;
      width: 100%; //height: 88/@rem-size;
      //line-height: 88/@rem-size;
      box-sizing: border-box;
      padding: 0 24 / @rem-size;
      color: #3e3e3e;
      font-size: 28 / @rem-size;
      border: 1px solid #e6e6e6;
      background: #f7f7f7;
      border-radius: 10 / @rem-size;
      -webkit-appearance: none;
      padding: 0.22rem 0.24rem;
    }

    input {
      display: block;
      width: 100%; //height: 88/@rem-size;
      //line-height: 88/@rem-size;
      box-sizing: border-box;
      padding: 0 24 / @rem-size;
      color: #3e3e3e;
      font-size: 28 / @rem-size;
      border: 1px solid #e6e6e6;
      background: #f7f7f7;
      border-radius: 10 / @rem-size;
      -webkit-appearance: none;
      padding: 0.22rem 0.24rem;
    }
  }

  .textarea {
    display: block;

    textarea {
      display: block;
      width: 100%;
      border: 1px solid #e6e6e6;
      border-radius: 10 / @rem-size;
      background: #f7f7f7;
      box-sizing: border-box;
      padding: 0 20 / @rem-size;
      line-height: 88 / @rem-size;
      resize: none;
      font-size: 28 / @rem-size;
    }
  }

  .radio-group {
    display: block;

    label {
      display: block;
      line-height: 80 / @rem-size;
      font-size: 28 / @rem-size;
      color: #3e3e3e;
      position: relative;
      box-sizing: border-box;
      padding-left: 50 / @rem-size;
      float: left;
      margin-right: 20 / @rem-size;

      i {
        display: block;
        width: 40 / @rem-size;
        height: 40 / @rem-size; // background: url('../../assets/images/radio-checkbox-bg.png') 0 0 no-repeat;
        background-size: cover;
        position: absolute;
        left: 0;
        top: 50%;
        margin-top: -20 / @rem-size;
        background-position: -40 / @rem-size 0;
      }

      input[type='radio'] {
        -webkit-appearance: none !important;
        position: absolute;
        left: 9999px;

        &:checked {
          + i {
            background-position: 0 0;
          }
        }
      }
    }
  }

  .checkbox-group {
    display: block;

    label {
      display: block;
      line-height: 80 / @rem-size;
      font-size: 28 / @rem-size;
      color: #3e3e3e;
      position: relative;
      box-sizing: border-box;
      padding-left: 50 / @rem-size;

      i {
        display: block;
        width: 40 / @rem-size;
        height: 40 / @rem-size; // background: url('../../assets/images/radio-checkbox-bg.png') 0 0 no-repeat;
        background-size: cover;
        position: absolute;
        left: 0;
        top: 50%;
        margin-top: -20 / @rem-size;
        background-position: -120 / @rem-size 0;
      }

      input[type='checkbox'] {
        -webkit-appearance: none !important;
        display: none;

        &:checked {
          + i {
            background-position: -80 / @rem-size 0 !important;
          }
        }
      }
    }
  }

  .select-single {
    .select {
      display: block;
      float: left;
      width: 100%;
      margin-right: 5%;
      position: relative;

      &:after {
        display: block;
        content: '';
        width: 0;
        height: 0;
        border: 10 / @rem-size solid #6d6d6d;
        border-color: #6d6d6d transparent transparent transparent;
        position: absolute;
        right: 20 / @rem-size;
        top: 50%;
        margin-top: -5 / @rem-size;
      }

      select {
        height: 88 / @rem-size;
        line-height: 88 / @rem-size;
        background: #f7f7f7;
        border-radius: 10 / @rem-size;
        display: block;
        width: 100%;
        outline: none;
        font-size: 28 / @rem-size;
        box-sizing: border-box;
        padding: 0 20 / @rem-size;
        border: 1px solid #e6e6e6;
        -webkit-appearance: none;
      }
    }
  }

  .select-group {
    &:after {
      display: block;
      content: '';
      clear: both;
    }

    .select {
      display: block;
      float: left;
      width: 30%;
      margin-right: 5%;
      position: relative;

      &:after {
        display: block;
        content: '';
        width: 0;
        height: 0;
        border: 10 / @rem-size solid #6d6d6d;
        border-color: #6d6d6d transparent transparent transparent;
        position: absolute;
        right: 20 / @rem-size;
        top: 50%;
        margin-top: -5 / @rem-size;
      }

      &:last-child {
        margin-right: 0 !important;
      }

      select {
        height: 88 / @rem-size;
        line-height: 88 / @rem-size;
        background: #f7f7f7;
        border-radius: 10 / @rem-size;
        display: block;
        width: 100%;
        outline: none;
        font-size: 28 / @rem-size;
        box-sizing: border-box;
        padding: 0 20 / @rem-size;
        border: 1px solid #e6e6e6;
        -webkit-appearance: none;
        position: relative;
      }
    }
  }
}

.personal-form form,
.company-form form {
  background: white;
  padding-top: 20 / @rem-size;
  padding-bottom: 20 / @rem-size;
}

.btn-next {
  display: block;
  width: 100%;
  height: 80 / @rem-size;
  text-align: center;
  line-height: 80 / @rem-size;
  color: white;
  font-size: 30 / @rem-size;
  margin: 40 / @rem-size auto;
  position: fixed;
  bottom: 0;
  left: 0;
  margin: auto;

  &:active {
    opacity: 0.9;
  }
}
</style>
